// extracted by mini-css-extract-plugin
export default {"tablePath":"tablePath_tablePath__87X7P"};